import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalLogisticUpdate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateLogistic');
  const onClose = () => {
    closeSingleModal('updateLogistic');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar logística"
      height={'auto'}
      width={'60vw'}
      backgroundColor={'#ececec'}
    >
      <Form.Export.Logistic.Update />
    </Modal>
  );
};

export default ModalLogisticUpdate;
